import React, { useEffect, useState, useContext } from "react";
import { Button, Input, Label } from "reactstrap";
import Alert from "react-s-alert";
import { useHistory } from "react-router-dom";
import PsychometricService from "../../services/PsychometricService";
import { ThemeContext } from "../../contexts/ThemeContext";
import { PsychometricContext } from "../../contexts/PsychometricContext";
import GeneralNavbar from "../general/GeneralNavbar";
import ErrorBoundary from "../general/ErrorBoundary";
import PsychometricTestMainNavbar from './PsychometricTestMainNavbar';
import Message from '../general/Message';

const PsychometricOrganizationTestTakerPortal = (props) => {
  const history = useHistory();
  const { theme } = useContext(ThemeContext);
  const {
    setSignedID,
    setSignedFirstName,
    setSignedLastName,
    setSignedOrganization,
    setIsOrganization,
    setIsStudent
  } = useContext(PsychometricContext);

  const [user, setUser] = useState({
    uniqueID: "",
    firstName: "",
    lastName: "",
    organization: "",
    otp: ""
  });
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState({ msgBody: '', msgError: false });
  const [isTwoFactorOn, setIsTwoFactorOn] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(props.location.search);
    setUser({
      uniqueID: params.get("id") || "",
      firstName: params.get("firstName") || "",
      lastName: params.get("lastName") || "",
      organization: params.get("organization") || "",
    });
  }, [props.location.search]);

  const handleChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const { uniqueID, firstName, lastName, otp } = user;

      const orgResponse = await PsychometricService.getUserOrganization(uniqueID, firstName, lastName);

      const organization = orgResponse.user.organization;
      

      const completionStatus = await PsychometricService.checkTestCompletion(
        uniqueID,
        firstName,
        lastName,
        organization,
        null
      );
      console.log("Completion status:", completionStatus);

      if (completionStatus.hasCompletedTest) {
        setMessage({ 
          msgBody: "You have already completed the test. You cannot take it again.", 
          msgError: true 
        });
        setIsLoading(false);
        return;
      }

      const userDetails = await PsychometricService.getPsychometricUser(
        uniqueID,
        firstName,
        lastName,
        organization
      );
      
      const orgDetails = await PsychometricService.getPsychometricOrganization(userDetails.user.organizationEmail);
  
      
      if (!orgDetails.user.isPrivate) {
     
        if (!isTwoFactorOn) {
          const otpResponse = await PsychometricService.sendTestTakerOTP(uniqueID, firstName, lastName);
          setIsTwoFactorOn(true);
          setMessage({ msgBody: "Please check your email for the OTP code", msgError: false });
          setIsLoading(false);
          return;
        }
        if (!otp) {
          setMessage({ msgBody: "Please enter the OTP sent to your email", msgError: true });
          setIsLoading(false);
          return;
        }

        try {
          await PsychometricService.verifyTestTakerOTP(uniqueID, firstName, lastName, otp);
        } catch (error) {
          setMessage({ msgBody: error.message?.msgBody || "Invalid OTP", msgError: true });
          setIsLoading(false);
          return;
        }
      }

      if (userDetails?.user) {
        setSignedID(uniqueID);
        setSignedFirstName(firstName);
        setSignedLastName(lastName);
        setSignedOrganization(orgResponse.user.organization);
        setIsOrganization(true);
        
        setIsStudent(orgDetails.user.isStudent);

        await PsychometricService.updateUserOrganizationInfo(
          uniqueID,
          firstName,
          lastName,
          orgResponse.user.organization
        );

        setMessage({ msgBody: "User authenticated successfully", msgError: false });
        history.push(`/psychometrictest/${encodeURIComponent(uniqueID)}/${encodeURIComponent(firstName)}/${encodeURIComponent(lastName)}/${encodeURIComponent(orgResponse.user.organization)}`);
      } else {
        setMessage({ msgBody: "User not found. Please check your credentials or contact your organization.", msgError: true });
      }
    } catch (error) {
      if (error.message?.msgBody === 'User not found') {
        setMessage({ 
          msgBody: "User not found. Please check your credentials or check with your organization", 
          msgError: true 
        });
      } else if (error.response?.data?.message?.msgBody === "Test already completed") {
        setMessage({ 
          msgBody: "You have already completed the test. You cannot take it again.", 
          msgError: true 
        });
      } else if (error.response) {
        setMessage({ 
          msgBody: error.response.data.message || "User not found. Please check your credentials or check with your organization", 
          msgError: true 
        });
      } else if (error.request) {
        setMessage({ 
          msgBody: "Unable to connect to the server. Please try again later.", 
          msgError: true 
        });
      } else {
        setMessage({ 
          msgBody: "User not found. Please check your credentials or check with your organization", 
          msgError: true 
        });
      }
      console.error('Full error details:', {
        error,
        user: user
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <ErrorBoundary errorAt="At Organization Test Taker Portal Navbar">
        <PsychometricTestMainNavbar />
      </ErrorBoundary>
      
      <div className="text-center mt-4">
        <h1 style={theme.headingXXL}>Organization Test Taker Portal</h1>
      </div>
      
      <div className="p-3 col-md-4 mt-5 mb-5 offset-md-4" style={theme.form}>
        <form onSubmit={handleSubmit} style={{ paddingLeft: "10%", paddingRight: "10%" }}>
          <h2 id="login-heading" style={{ ...theme.heading, textAlign: "center" }}>
            Organization Test Taker 
          </h2>
          <h2 style={{ ...theme.heading, textAlign: "center" }}>
            Sign In
          </h2>
          <ErrorBoundary errorAt="At Organization Test Taker Portal Message">
            {message.msgBody ? <Message message={message} /> : null}
          </ErrorBoundary>
          <br />
          <p style={{ ...theme.formBodyText, color: '#666666', fontStyle: 'italic', marginBottom: '15px' }}>
            An organization must provide you with a user code
          </p>
          <Label htmlFor="uniqueID" style={theme.formBodyText}>
            User Code
          </Label>
          <Input
            type="text"
            id="uniqueID"
            name="uniqueID"
            value={user.uniqueID}
            onChange={handleChange}
            className="form-control"
            required
            style={theme.formInput}
          />
          <br />
          <Label htmlFor="firstName" style={theme.formBodyText}>
            First Name
          </Label>
          <Input
            type="text"
            id="firstName"
            name="firstName"
            value={user.firstName}
            onChange={handleChange}
            className="form-control"
            required
            style={theme.formInput}
          />
          <br />
          <Label htmlFor="lastName" style={theme.formBodyText}>
            Last Name
          </Label>
          <Input
            type="text"
            id="lastName"
            name="lastName"
            value={user.lastName}
            onChange={handleChange}
            className="form-control"
            required
            style={theme.formInput}
          />
         
          {isTwoFactorOn && (
            <div>
              <Label htmlFor="otp" style={theme.formBodyText}>
                OTP
              </Label>
              <Input
                type="text"
                id="otp"
                name="otp"
                value={user.otp}
                onChange={handleChange}
                className="form-control"
                required
                style={theme.formInput}
              />
              <br />
            </div>
          )}

          <br />  
            <div className="text-center mt-4">
          <Button
            type="submit"
            color="primary"
            disabled={isLoading}
            style={theme.formSubmit}
          >
            {isLoading ? (
              <span className="spinner-border spinner-border-sm mr-1"></span>
            ) : null}
            {isTwoFactorOn ? "Verify OTP" : "Sign In"}
          </Button>
            </div>
          <div className="text-center mt-3 p-2" style={{ backgroundColor: '#f5f5f5', borderRadius: '4px' }}>
            <p style={{ ...theme.formBodyText, color: '#000000' }}>
              New Organization?
              <br />
              <a 
                href="/psychometricOrgSignUp" 
                style={{ 
                  ...theme.link, 
                  textDecoration: 'underline', 
                  cursor: 'pointer',
                  color: '#28a745'
                }}
                onClick={(e) => {
                  e.preventDefault();
                  history.push('/psychometricOrgSignUp');
                }}
              >
                Sign up here
              </a>
            </p>
          </div>
        </form>
      </div>

      <div className="text-center mt-4">
      <Button
            type="button"
            color="secondary"
            style={theme.formSubmit}
            className="ml-2"
            onClick={() => history.push('/')}
          >
           Return to Home
          </Button>
      </div>
    </div>
  );
};

export default PsychometricOrganizationTestTakerPortal;
